export const blogAppUrl = `${process.env.NEXT_PUBLIC_BLOG_PROTOCOL}://${process.env.NEXT_PUBLIC_BLOG_HOST}:${process.env.NEXT_PUBLIC_BLOG_PORT}`
